import dayjs from 'dayjs'
import {HeaderProps} from 'react-big-calendar'

export const AgendaCalendarHeader = ({date}: HeaderProps) => {
    const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    return <span>{days[dayjs(date).day() == 0 ? 6 : dayjs(date).day() - 1]}</span>
}
